// @flow

import { observer } from "mobx-react";
import React from "react";

import Dispatcher from "app/util/Dispatcher";

import type { Props } from "app/components/TimelineCard/TimelineCard";
import ShortComment from "app/components/ShortComment/ShortComment";
import VideoPlayer from "app/components/VideoPlayer/VideoPlayer";
import VideoPlayerPreview from "app/components/VideoPlayerPreview/VideoPlayerPreview";
import AppearanceStore from "app/stores/AppearanceStore";
import ImageHelper from "app/util/ImageHelper";

import "./VideoTimelineCard.scss";

@observer
export default class VideoTimelineCard extends React.Component<Props> {
    stateDispatcher: Dispatcher = new Dispatcher();

    get thumbnail(): string {
        return this.props.item.metaImage
            ? ImageHelper.makeUrl(this.props.item.metaImage.src)
            : "";
    }
        get length(): number {
        return AppearanceStore.timelineContentLength;
    }

    render() {
        return this.props.isVerticalView
            ? this.renderVerticalView()
            : this.renderHorizontalView();
    }

    renderVerticalView() {
        return this.props.isExpanded
            ? this.renderVerticalViewExpanded()
            : this.renderVerticalViewShrunk();
    }

    renderVerticalViewExpanded() {
        const item = this.props.item;
        const classes = ["VideoTimelineCard", "TimelineCard--overlayable"];

        return (
            <div className={classes.join(" ")}>
                <ShortComment
                    itemId={item.rowid}
                    comment={item.comment}
                    length={this.length}
                />

                <div className="TimelineCard--overlayable__image">
                    {this.renderVideoPlayer(true, true)}
                </div>

                <div className="TimelineCard--overlayable__content">
                    {item.metaTitle && (
                        <div className="TimelineCard--overlayable__title">
                            {item.metaTitle}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderVerticalViewShrunk() {
        const item = this.props.item;
        const hasText = item.metaTitle || item.metaDescription || item.comment.length > 0;
        const imageContainerClass = hasText 
            ? "TimelineCard--linkable__imageContainer"
            : "TimelineCard--linkable__imageContainer_notext";            
        return (
            <div className="VideoTimelineCard">
                <div onClick={this.props.onExpand}>
                    <div className="TimelineCard--linkable">
                        <div className="TimelineCard--linkable__container">
                            <div className={imageContainerClass}>
                                { this.props.isExpanded 
                                    ? this.renderVideoPlayer(true, true)
                                    : (
                                        <div className="TimelineCard--linkable__imageContainer">
                                            <VideoPlayerPreview
                                                thumbnail={this.thumbnail}
                                                onPlay={this.props.onExpand}
                                                showPlayButton={true}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                            {hasText &&
                                <div className="TimelineCard--linkable__titleAndDescriptionContainer">
                                    {item.metaTitle && (
                                        <div className="TimelineCard--linkable__title">
                                            {item.metaTitle}
                                        </div>
                                    )}

                                    {item.metaDescription && (
                                        <div className="TimelineCard--linkable__description">
                                            {item.metaDescription}
                                        </div>
                                    )}

                                    <ShortComment
                                        itemId={item.rowid}
                                        comment={item.comment}
                                        length={this.length}
                                        onReadMore={this.handleReadMore}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderHorizontalView() {
        const item = this.props.item;
        const classes = ["VideoTimelineCard", "TimelineCard--overlayable"];

        return (
            <div className={classes.join(" ")}>
                <ShortComment
                    itemId={item.rowid}
                    comment={item.comment}
                    length={this.length}
                    key={item.rowid}
                    onReadMore={this.handleReadMore}
                />

                <div className="TimelineCard--overlayable__image">
                    { this.props.isExpanded
                        ? this.renderVideoPlayer(true, true)
                        : (
                            <VideoPlayerPreview
                                thumbnail={this.thumbnail}
                                onPlay={this.props.onExpand}
                                showPlayButton={true}
                            />
                        )
                    }
                </div>

                <div className="TimelineCard--overlayable__content">
                    {item.metaTitle && (
                        <div className="TimelineCard--overlayable__title">
                            {item.metaTitle}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderVideoPlayer(enabled: boolean, unExpandAfterEnded: boolean) {
        const item = this.props.item;
 
        const videoUrls =
            this.props.item.metadata && this.props.item.metadata.video
                ? this.props.item.metadata.video
                : { "video/webm": item.image };

        if (enabled) {
            return (
                <VideoPlayer
                    source={item.type}
                    originalId={item.type_id}
                    videoUrls={videoUrls}
                    thumbnail={this.thumbnail}
                    autoPlay={true}
                    onPlay={this.props.onRequestPauseMainVideo}
                    onEnded={
                        unExpandAfterEnded ? this.props.onUnExpand : null
                    }
                />
            );
        }

        return null;
    }

    handleReadMore = () => {
        this.props.onExpand();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/VideoTimelineCard/VideoTimelineCard.js